export default __webpack_public_path__ + "static/media/NotoSans-ExtraBold.385f0f12.woff2";